import Vue from 'vue'
import App from './App.vue'
import router from './config/router.js'
import store from './config/store.js'
import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'
import axios from 'axios'

Vue.use(VueMaterial)

//axios
Vue.prototype.$axios = axios

//CSS
import '@/css/main.min.css'

import apiHeandlerMi from '@/mixins/apiHandlerMI.js';
import globalMi from '@/mixins/globalMI.js';
Vue.mixin(apiHeandlerMi)
Vue.mixin(globalMi)

import VueObserveVisibility from 'vue-observe-visibility'

Vue.use(VueObserveVisibility)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

